import { create } from 'zustand';

export interface SyncProgress {
  phase: 'headers' | 'bodies' | 'idle';
  done: number;
  total: number;
  updatedAt: number;
}

interface SyncState {
  byAccount: Record<number, SyncProgress>;
  setProgress: (accountId: number, p: Omit<SyncProgress, 'updatedAt'>) => void;
}

export const useSyncStore = create<SyncState>()((set) => ({
  byAccount: {},
  setProgress: (accountId, p) =>
    set((s) => ({
      byAccount: { ...s.byAccount, [accountId]: { ...p, updatedAt: Date.now() } },
    })),
}));
